export default __webpack_public_path__ + "static/media/book9.a4a4c2ae.svg";